export const downloadFile = (file: File) => Promise.resolve(file);
